import { Table, Button, Popconfirm } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { message } from 'antd';
import axios from "./../../../services/http";

const TablaPerfil = ({ data, loading, setLoading, GetProfiles, EditProfile }) => {

    const DeleteProfile = async (id) => {
        try {
            setLoading(true);
            const response = await axios.HTTP_POST("/api/v1/profiles/delete", { id });
            message.success(response.data.message);
            GetProfiles();
        } catch (e) {
            console.error('Error al eliminar el perfil:', e);
            message.error('Error al eliminar el perfil');
        } finally {
            setLoading(false);
        }
    }

    const columns = [
        {
            title: 'Perfil',
            dataIndex: 'name',
            key: 'name',
            fixed: 'left',
        },
        {
            title: 'Acciones',
            dataIndex: 'actions',
            key: 'actions',
            align: 'center',
            render:((_, item) => 
                <>
                    <div style={{ textAlign: "center" }}>
                        <Button color="primary" variant="filled" className='mr-5' onClick={() => EditProfile(item.id)}>
                            <EditOutlined />
                        </Button>
                        <Popconfirm title="¿Quieres eliminar este perfil?" onConfirm={() => DeleteProfile(item.id)}>
                            <Button color="danger" variant="filled">
                                <DeleteOutlined />
                            </Button>
                        </Popconfirm>
                    </div>
                </>
            )
        }
    ];

    return (
        <>
            <Table 
                dataSource={data} 
                columns={columns} 
                rowKey="id" 
                loading={loading} 
                scroll={{
                    x: 'max-content',
                }}
            />
        </>
    );
}

export default TablaPerfil;